export function formatAdolescenteNome(adolescente) {
  const nomeCompleto = (adolescente?.nome_adolescente ?? '').trim();
  const nomeSocial = (adolescente?.nome_social ?? '').trim();

  if (nomeCompleto && nomeSocial) {
    return `${nomeCompleto} (${nomeSocial})`;
  }

  if (nomeCompleto) {
    return nomeCompleto;
  }

  if (nomeSocial) {
    return nomeSocial;
  }

  return '—';
}
